import { Injectable, Output, EventEmitter } from '@angular/core';
import { ApiGatewayService } from '../services/api-gateway.service';
import { ServiceObject } from 'src/app/model/service-object';

@Injectable({
  providedIn: 'root'
})
export class LicenseControlBusinessService {

  constructor(private apiGatewayService: ApiGatewayService) { }

  private timer;
  @Output() LicenseEvent = new EventEmitter();
  
  StartVerification()
  {
    this.ValidateLicense().then(x=> {
      this.timer = setInterval(() => {
        this.ValidateLicense().catch(x=> {
          this.StopVerification();
          this.LicenseEvent.emit(x);
        });
      },1000 * 60 * 60 );//* 60
    }).catch(x=>{
      this.LicenseEvent.emit(x);
    });
    
  }

  StopVerification()
  {
    clearInterval(this.timer);
  }


  ValidateLicense(): Promise<boolean> {
    var servObj = new ServiceObject("RoleManager", "LicenseControl", "ValidateLicense");
    return this.apiGatewayService.PostAnonymousAction(servObj)
      .then(x => {
        servObj = x as ServiceObject;
        
        if (!servObj.Success)
          throw new Error(servObj.Message);       
        
        return Promise.resolve(servObj.Success);              
      })
      .catch(x => {
        throw x.message;
      });
  }
}
